import React from 'react';
import ReactDOM from "react-dom";
import MaterialTable from 'material-table';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';

export default class VaccinationsTable extends React.Component {
  constructor(props) {
    super(props);
    this.theme = createMuiTheme({
      palette: {
        primary: {
          main: '#7cb342',
        },
        secondary: {
          main: '#4caf50',
        },
      },
    });

    this.state = {
      columns: [
        { title: 'Company', field: 'company', width: 200},
        { title: 'Batch', field: 'batch_name'},
        { title: 'Location', field: 'address', width: 500, grouping: false },
        { title: 'Participants', field: 'participants' },
        { title: 'Contact Person', field: 'contact_person', width: 150},
        { title: 'Status', field: 'status'},
        { title: 'Date', field: 'date', width: 130 },
      ],
      data: null,
      page: null,
      totalCount: null
    }

    this.tableRef = React.createRef();
  }

  render () {
    return (
      <MuiThemeProvider theme={this.theme}>
        <MaterialTable
          title="Corporate Vaccinations"
          tableRef={this.tableRef}
          columns={this.state.columns}
          data={query =>
            new Promise((resolve, reject) => {
              let url = '/api/vaccinations.json?'
              // console.log('params', query)
              url += 'per_page=' + query.pageSize
              url += '&q=' + query.search
              url += '&page=' + (query.page + 1)
              fetch(url)
                .then(response => response.json())
                .then(result => {
                  // console.log('row data', result.accounts.data)
                  resolve({
                    data: result.vaccinations,
                    page: result.pagination.page - 1,
                    totalCount: result.pagination.count,
                  })
                })
            })
          }

          actions={[
            {
              icon: 'refresh',
              tooltip: 'Refresh Data',
              isFreeAction: true,
              onClick: () => this.tableRef.current && this.tableRef.current.onQueryChange(),
            }
          ]}
          options={{
            pageSize: 10,
            pageSizeOptions: [10, 20, 30, 50, 100],
            exportButton: true,
            sorting: true,
            search: true,
            grouping: true
            // tableLayout: 'fixed'

          }}
          onRowClick={(event, rowData) => Turbolinks.visit(rowData.url)}
        />
      </MuiThemeProvider>
      

    );
  }

}

